<template>
    <div class="container pt-3 pt-lg-4 pb-lg-4 pl-4 pr-4">
        <div>
            <div class="wrapper-progressBar" id="progressBarAnchor">
                <ul class="progressBar d-none d-md-flex justify-content-md-around">
                    <StepFormIcon :step="1" v-bind:currentIndexStep="getIndexStep">{{ TEXTS.render("BOOKING_STEPS_ONE") }}</StepFormIcon>
                    <StepFormIcon :step="2" v-bind:currentIndexStep="getIndexStep">{{  TEXTS.render("BOOKING_STEPS_TWO")  }}</StepFormIcon>
                    <StepFormIcon :step="3" v-bind:currentIndexStep="getIndexStep" v-show="defaultSteps == 3">{{ TEXTS.render("BOOKING_STEPS_THREE", servicePaymentType) }}</StepFormIcon>
                </ul>
                <div class="row d-md-none">
                    <div class="col-4" id="progress-container">
                        <div class="progress-radial progress-0 setsize" :class="[progressPercent]">
                            <div class="overlay setsize d-flex flex-column justify-content-center">
                                <div class="font-weight-bold text-center overlay-text">{{ getIndexStep >= totalSteps ? totalSteps : getIndexStep+1 }} of {{ this.totalSteps }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-8 d-flex flex-column justify-content-center pl-0">
                        <h6 class="font-weight-bold mb-0" v-if="getIndexStep == 0">{{TEXTS.render("BOOKING_STEPS_ONE")}}</h6>
                        <h6 class="font-weight-bold mb-0" v-if="getIndexStep == 1">{{ TEXTS.render("BOOKING_STEPS_TWO") }}</h6>
                        <h6 class="font-weight-bold mb-0" v-if="getIndexStep == 2 && bookingState.selectedService && bookingState.selectedService.is_paid">{{ TEXTS.render("BOOKING_STEPS_THREE", servicePaymentType) }} </h6>
                        <h6 class="font-weight-bold mb-0" v-if="getIndexStep == 3">Booking Completed</h6>
                        <span class="d-inline-block" v-if="getIndexStep == 0"><strong class="font-weight-bold">Next: </strong> {{ TEXTS.render("BOOKING_STEPS_TWO") }}</span>
                        <span class="d-inline-block" v-if="getIndexStep == 1"><strong class="font-weight-bold">Next: </strong> {{ TEXTS.render("BOOKING_STEPS_THREE", servicePaymentType) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BookingStateManager from '../../../../common/utils/BookingStateManager';
    import StepFormIcon from './StepFormIcon';
    import Helper from '../../../../helper'
    import Texts from '../../../../common/utils/Texts'
    import MultipleServiceSelectedBooking from '../../../../common/utils/MultipleServiceSelectedBooking';

    function renderProgressRadial() {
        const progressradials = document.querySelectorAll('.progress-radial');
        if (progressradials.length > 0) {
            const progress = progressradials[0];
            progress.style.display = 'block';
            progress.style.height = (progress.offsetWidth + 'px');
        }
    }
    export default {
        components: {
            StepFormIcon
        },
        data() {
            return {
                progressPercent: 0,
                defaultSteps: 3
            }
        },
        mounted() {
            this.initTabs();
        },
        methods: {
            initTabs() {
                setTimeout(() => {
                    renderProgressRadial();
                    this.calculateProgress;
                }, 1000);

                window.addEventListener('resize', function(event){
                    renderProgressRadial();
                });
            },
        },
        watch: {
            'getIndexStep': function(n) {
                this.initTabs();
                this.defaultSteps = this.totalSteps;
                this.$store.dispatch('setTotalSteps', this.defaultSteps);
            }
        },
        computed: {
            TEXTS(){
                return Texts
            },
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE;
            },
            getIndexStep() {
                return this.$store.getters.GET_ACTIVEFORM_INDEX;
            },
            personalInfoType(){
                return this.$store.getters.GET_PERSONAL_INFO.type
            },
            totalSteps() {
                var bookingState = this.bookingState;
                let countStep = 3;
                if(bookingState && bookingState.selectedService) {
                    if (!this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
                        if(bookingState.selectedService.is_paid == 1) {
                            return countStep = 2;
                        } else{
                            return countStep = 3;
                        }
                    } else {
                        return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.some(product => product.isPaid) ? 3 : 2;
                    }
                }

                return countStep;
            },
            calculateProgress() {
                this.progressPercent = 'progress-' + Math.round(((this.getIndexStep > this.totalSteps) ? 1 : this.getIndexStep / this.totalSteps) * 100);
            },
            MainUISettings() {
                return this.$store.getters['GET_MAIN_UI']; 
            },
            userInfoDescription(){
                var userType

                switch(this.personalInfoType){
                    case "resident" :
                        userType = "Personal Info"
                        break
                    case "cso" :
                        userType = "Resident Info"
                        break
                }

                return userType
            },
            servicePaymentType(){
                var selectedService = this.bookingState ? this.bookingState.selectedService : null
                return selectedService && selectedService.is_paid == 2 ? 'paid' : 'free'
            },
        }
    }
</script>

<style scoped>
.progressBar{
    padding-inline-start: 0px;
    padding-top: 1rem;
}
</style>